import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { useForm, Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { API_HANDLERS } from 'api/apiHandlers';
import { alert } from 'components';
import { Links } from 'settings';
import { ActivateUserPasswordFormValues } from 'types';

import { defaultValues } from './config';

interface UseCreatePasswordFormReturn {
  isLoading: boolean;
  handleFormSubmit: () => void;
  control: Control<ActivateUserPasswordFormValues>;
}

interface LocationState {
  ott: string;
}

export function useCreatePasswordForm(employeeActivation?: boolean): UseCreatePasswordFormReturn {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { control, handleSubmit, setValue } = useForm<ActivateUserPasswordFormValues>({
    defaultValues,
    mode: 'onBlur',
    reValidateMode: 'onChange',
  });

  const { t } = useTranslation();
  const ott = (state as LocationState)?.ott;

  const { mutateAsync: createPasswordResetMutation, isLoading } = useMutation(
    API_HANDLERS.AUTH.FINISH_ACTIVATION,
    {
      onSuccess: () => {
        alert.success(
          employeeActivation
            ? t('activateEmployee.accountactivated')
            : t('activateEmployee.passwordCreated'),
        );
        navigate(Links.auth.signIn);
      },
    },
  );

  const handleFormSubmit = handleSubmit(async ({ password }) => {
    await createPasswordResetMutation({ user: { password }, ott });
  });

  const submit = async () => {
    setIsSubmitting(true);
    if (employeeActivation) {
      setValue('password', 'DummyPassword123!');
    }
    await handleFormSubmit();
    setIsSubmitting(false);
  };

  return {
    isLoading: isSubmitting || isLoading,
    control,
    handleFormSubmit: submit,
  };
}
